// Triple-state model — declared once, consumed by both list & detail views.
export const TECHNICAL_STATES = [
    { key: "not_started", label: "Not started", tone: "slate", hint: "No invoices yet" },
    { key: "in_progress", label: "In progress", tone: "indigo", hint: "Partial delivery" },
    { key: "partial_go_live", label: "Partial go-live", tone: "violet", hint: "Phased rollout" },
    { key: "completed", label: "Completed", tone: "emerald", hint: "Delivery finished" },
];

export const COMMERCIAL_STATES = [
    { key: "open", label: "Open", tone: "amber", hint: "Awaiting first payment" },
    { key: "partially_settled", label: "Partially settled", tone: "indigo", hint: "Some payment in" },
    { key: "settled", label: "Settled", tone: "emerald", hint: "Fully paid" },
    { key: "disputed", label: "Disputed", tone: "rose", hint: "Operator flagged" },
    { key: "written_off", label: "Written off", tone: "slate", hint: "Accounting closure" },
];

export const SUPPORT_STATES = [
    { key: "inactive", label: "Inactive", tone: "slate", hint: "No AMC yet" },
    { key: "pre_amc", label: "Pre-AMC", tone: "amber", hint: "Awaiting activation" },
    { key: "amc_active", label: "AMC active", tone: "emerald", hint: "Under support" },
    { key: "amc_lapsed", label: "AMC lapsed", tone: "rose", hint: "Renewal pending" },
];

export const STATE_TONE = {
    not_started: "bg-slate-50 text-slate-700 border-slate-200",
    in_progress: "bg-indigo-50 text-indigo-700 border-indigo-200",
    partial_go_live: "bg-violet-50 text-violet-700 border-violet-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",

    open: "bg-amber-50 text-amber-700 border-amber-200",
    partially_settled: "bg-indigo-50 text-indigo-700 border-indigo-200",
    settled: "bg-emerald-50 text-emerald-700 border-emerald-200",
    disputed: "bg-rose-50 text-rose-700 border-rose-200",
    written_off: "bg-slate-100 text-slate-600 border-slate-300",

    inactive: "bg-slate-50 text-slate-700 border-slate-200",
    pre_amc: "bg-amber-50 text-amber-700 border-amber-200",
    amc_active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amc_lapsed: "bg-rose-50 text-rose-700 border-rose-200",
};

export const STATE_LABEL = {
    not_started: "Not started", in_progress: "In progress",
    partial_go_live: "Partial go-live", completed: "Completed",
    open: "Open", partially_settled: "Partially settled",
    settled: "Settled", disputed: "Disputed", written_off: "Written off",
    inactive: "Inactive", pre_amc: "Pre-AMC", amc_active: "AMC active",
    amc_lapsed: "AMC lapsed",
};
